export default [
  {
    srno: "1",
    channelname:"the caregiver saathi",
    admins: "7",
    status: "Public",
    members: "5",
    posts: "10"
  },
  {
    srno: "2",
    channelname:"the caregiver saathi",
    admins: "7",
    status: "Public",
    members: "5",
    posts: "10"
  },
  {
    srno: "2",
    channelname:"the caregiver saathi",
    admins: "7",
    status: "Private",
    members: "5",
    posts: "10"
  },
  {
    srno: "2",
    channelname:"the caregiver saathi",
    admins: "7",
    status: "Private",
    members: "5",
    posts: "10"
  }
];
